export const EmailSenderTypes = {
  FORGOTTEN_PASSWORD: "FORGOTTEN_PASSWORD",
  FORGOTTEN_USERNAME: "FORGOTTEN_USERNAME",
  ACTIVATION_LINK: "ACTIVATION_LINK",
  UPDATE_EMAIL: "UPDATE_EMAIL",
};
